import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateHelper, StringHelper } from 'apps/idl/src/helpers';
import { ETimetablePattern } from 'apps/idl/src/model';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { PatientHelper } from '../../helpers/patient.helper';
import { SSNHelper } from '../../helpers/ssn.helper';

@Component({
  selector: 'di-dossier-patient',
  templateUrl: './dossier-patient.component.html',
  styleUrls: ['./dossier-patient.component.scss'],
})
export class DossierPatientComponent implements OnInit {

  @Input() public patient?: IPatient;
  @Input() public selected: boolean = false;
  @Output() select = new EventEmitter<IPatient>();

  public nameString: string;
  public birthDateString: string;
  public ssnString: string;
  public gender: string;
  public genderColor: string;
  public addressString: string;
  public updatedDateString: string;

  constructor(private svcPatients: PatientsService) {}

  ngOnInit(): void {
    if (this.patient) {
      const hasName = this.patient.lastName || this.patient.firstName;
      this.nameString = hasName
        ? PatientHelper.getFullNamePatient(this.patient) + (this.patient.firstName ? ' ' + StringHelper.toTitleCase(PatientHelper.getPatientFirstName(this.patient)) : '')
        : '-Nom non renseigné-';

      this.birthDateString = this.patient.birthDate
        ? 'Né' + (this.patient.gender === '2' ? 'e' : '') + ' le ' +
        DateHelper.transform(this.patient.birthDate, ETimetablePattern.dd_MM_yyyy_slash)
        : '-Date de naissance non renseignée-';

      this.ssnString = this.patient.socialNumber
        ? SSNHelper.formatSSN(this.patient.socialNumber)
        : '-Numéro de sécurité sociale non renseigné-';

      this.gender = this.svcPatients.getPatientGender(this.patient.gender);
      this.addressString = this.getAddress();

      this.updatedDateString = this.patient.updateDate
        ? 'Dossier mis à jour le ' + DateHelper.transform(this.patient.updateDate, ETimetablePattern.dd_MMM_yyyy)
        : '-Date de mise à jour non renseignée-';

      this.genderColor = this.svcPatients.setGenderColor(this.patient);
    }
  }

  public onClick(): void {
    this.select.emit(this.patient);
  }

  public getAddress(): string {
    const { street, zipCode, city } = this.patient || {};

    const addressParts = [
      street,
      [zipCode, city].filter(Boolean).join(' ')
    ].filter(Boolean);

    if (addressParts.length === 0) return '-Adresse non renseignée-'

    return addressParts.join(', ');
  }
}
